import { Currency } from '@/core/currency/interfaces';

const KHR: Currency = {
    name: 'Cambodian Riel',
    demonym: 'Cambodian',
    majorSingle: 'Riel',
    majorPlural: 'Riels',
    codeNumeric: '116',
    symbol: '៛',
    symbolNative: '៛',
    minorSingle: 'Sen',
    minorPlural: 'Sen',
    ISOdigits: 2,
    decimals: 2,
    numToBasic: 100,
    code: 'KHR',
    delimiters: {
        thousands: '.',
        decimal: ','
    }
};

export default KHR;
